import type { JSONSchemaType } from 'ajv'
import type { OptimizationGroupFormData } from '../model/types'

import { useTranslation } from 'react-i18next'

import { useSettingsSchemasQuery } from '@/entities/core'

import {
	getSchemaResolver,
	translateSchemaKeys,
} from '@/shared/tools/json-schema-utils'

export const useOptimizationGroupSchemaQuery = () => {
	const { t } = useTranslation()

	return useSettingsSchemasQuery<JSONSchemaType<OptimizationGroupFormData>>({
		select: (schemas) => {
			const resolver = getSchemaResolver(schemas)
			resolver.getDerefSchema('part:strategy')
			resolver.addSchema({
				$id: 'entity:optimization_group',
				type: 'object',
				required: ['name'],
				properties: {
					name: {
						type: 'string',
						minLength: 1,
					},
					description: {
						type: 'string',
					},
					sales_level_id: {
						type: 'number',
					},
					sales_entities: {
						type: 'array',
						items: {
							type: 'string',
						},
					},
					product_groups: {
						type: 'array',
						items: {
							type: 'object',
							required: ['product_group_id'],
							properties: {
								product_group_id: { type: 'string' },
								filters: {
									type: 'array',
									items: { type: 'object' },
									nullable: true,
								},
							},
						},
					},
					strategy: {
						$ref: 'part:strategy',
					},
					business: {
						$ref: 'part:business',
					},
					stop_list: {
						$ref: 'part:stop_list',
					},
				},
			})

			return translateSchemaKeys(
				resolver.getDerefSchema('entity:optimization_group'),
				t
			)
		},
	})
}
